import React from 'react';
import { get, chain } from 'lodash';
import { pluralize } from 'services/helpers/formatters';
import formatPrice, { formatCentsPrice } from 'services/helpers/formatPrice';

const LabelAmount = (props) => {
  const { record } = props;

  const labelPrice = get(record, 'details.labelPrice');
  const currency = Object.keys(get(record, 'amounts') ?? {}).find((key) => key !== 'LABEL');

  return <span>-{formatPrice(labelPrice, { currency })}</span>;
};

const AmountsField = (props) => {
  const { record, source } = props;

  const partiallyAvailable =
    record.status === 'PENDING' && record.details?.achAllocation?.instantAmountCents;

  if (partiallyAvailable) {
    return (
      <div>
        {!!record.details?.achAllocation?.instantAmountCents && (
          <span>{formatCentsPrice(record.details.achAllocation.instantAmountCents)}</span>
        )}
        {!!record.details?.achAllocation?.pendingAmountCents && (
          <>
            <br />
            <span>
              {formatCentsPrice(record.details.achAllocation.pendingAmountCents)} in 2-3 business
              days
            </span>
          </>
        )}
      </div>
    );
  }

  const handleAmount = (value, currency) => {
    if (currency === 'LABEL') {
      return pluralize(value, 'label');
    }

    return value.toLocaleString('en-US', { style: 'currency', currency });
  };

  const amountsObject: { [key: string]: number } = get(record, source);

  if (!amountsObject) {
    return <span>-</span>;
  }

  const amountsValue = chain(amountsObject)
    .map((value, currency) => ({ value, currency }))
    .sortBy(['currency.length', 'currency'])
    .map(({ value, currency }) => handleAmount(value, currency))
    .value();

  if (record?.type === 'PURCHASE' && !Object.keys(amountsObject ?? {}).includes('LABEL')) {
    return <LabelAmount record={record} />;
  }

  return <span>{amountsValue.join(', ')}</span>;
};

export default AmountsField;
